module.exports = __webpack_public_path__ + "static/cell-view-chart-297ebfe6824d518e41f762399d3ee7ee.svg";